/* eslint-disable */
/**
 * @description 工具函数
 * @author wangfupeng
 */

/**
 * 变量对象或数组
 * @param {Object} obj 原数据
 * @param {function} fn 回调函数
 */
function each(obj = {}, fn) {
    if (obj instanceof Array) {
        // 数组
        const { length } = obj;
        for (let i = 0; i < length; i++) {
            fn(i, obj[i]);
        }
    } else {
        // 对象
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                fn(key, obj[key]);
            }
        }
    }
}

/**
 * 深拷贝
 * @param {Object|Array} obj 即将深拷贝的对象或数组
 */
function cloneDeep(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    let result;
    if (obj instanceof Array) {
        // 数组
        result = [];
        each(obj, (index, value) => {
            result.push(
                cloneDeep(value),
            );
        });
    } else {
        // 对象
        result = {};
        each(obj, (key, value) => {
            result[key] = cloneDeep(obj[key]);
        });
    }
    return result;
}

/**
 * 查找所有key对应的id
 *
 * @author tianjingsi
 * @date 2019-10-16
 * @param {Array} data
 * @param {String} key
 * @returns {Array} id列表
 */
function findIdsByKey(data, key) {
    let ids = [];
    data.forEach((item) => {
        if (item.key === key) {
            ids.push(item.id);
        }
        if (item.children) {
            ids = ids.concat(findIdsByKey(item.children, key));
        }
    });
    return ids;
}

/**
 * 获取 DOM 节点父元素
 * @param {Object} dom DOM 元素节点
 * @param {string} selector 父元素选择器
 */
function getDomParent(dom, selector) {
    if (!selector) return dom.parentNode;
    let parent = null;
    let iterator = dom.parentNode;
    while (iterator && iterator !== document.body) {
        if (iterator.matches(selector)) {
            parent = iterator;
            break;
        }
        iterator = iterator.parentNode;
    }

    return parent;
}

var Query = {
    /**
   * url解析
   * @param  {string} url 需要解析的url，默认当前url
   * @return {obj}        返回包含host, url参数params, port...等属性值的对象字面量
   */
    decode(url) {
        url = url || window.location.href
        let a = document.createElement('a')
        a.href = url
        return {
            source: url,
            protocol: a.protocol.replace(':', ''),
            host: a.hostname,
            port: a.port,
            query: a.search,
            params: (function () {
                let ret = {};
                let seg = a.search.replace(/^\?/, '').split('&');
                let len = seg.length; let i = 0; let
                    s
                for (;i < len; i++) {
                    if (!seg[i]) { continue }
                    s = seg[i].split('=')
                    ret[decodeURIComponent(s[0])] = decodeURIComponent(seg[i].substr(s[0].length + 1))
                }
                return ret
            }()),
            hashParams: (function () {
                let ret = {};
                var seg = [];
                let hash = (a.hash && a.hash.indexOf('?') > -1) ? a.hash.replace(/^#.+\?/, '').split('&') : [];
                // eslint-disable-next-line no-redeclare
                var seg = seg.concat(hash);
                let len = seg.length; let i = 0; let
                    s

                for (;i < len; i++) {
                    if (!seg[i]) { continue }
                    s = seg[i].split('=')
                    ret[decodeURIComponent(s[0])] = decodeURIComponent(seg[i].substr(s[0].length + 1))
                }
                return ret
            }()),
            file: (a.pathname.match(/\/([^/?#]+)$/i) || [, ''])[1],
            hash: a.hash.replace('#', ''),
            path: a.pathname.replace(/^([^/])/, '/$1'),
            relative: (a.href.match(/tps?:\/\/[^/]+(.+)/) || [, ''])[1],
            segments: a.pathname.replace(/^\//, '').split('/')
        }
    },
    /**
   * 构建url
   * @param  {obj} data Query.decode解析后返回的obj
   * @return {string}   完整的url
   */
    encode(data) {
        let ret = []; let
            query = []

        ret.push(data.protocol, '://')
        ret.push(data.host)
        if (data.port) {
            ret.push(':', data.port)
        }
        ret.push(data.path)
        each(data.params, (val, key) => {
            if (val !== null) {
                query.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
            }
        })
        if (query.length > 0) {
            ret.push('?', query.join('&'))
        }
        if (data.hash) {
            ret.push('#', data.hash)
        }
        return ret.join('')
    },

    /**
   * 获取url参数
   * @param  {string} keys  查询的url参数名，多个参数逗号隔开
   * @param  {[type]} url   需要解析的url, 默认当前url
   * @return {string | obj} 查询的参数值：一个参数返回参数值；多个参数返回obj
   */
    get(keys, url, config) {
        if (arguments.length === 0) {
            return Query.decode()
        }

        let ret = {};
        let keysArr = keys.split(',');
        let data = Query.decode(url || window.location.href)

        let paramsKey = config && config.fromHash ? 'hashParams' : 'params'

        each(keysArr, (key, i) => {
            if (data[paramsKey][key]) {
                if (keysArr.length === 1) {
                    ret = data[paramsKey][key]
                    return false
                }
                ret[key] = data[paramsKey][key]
            } else {
                if (keysArr.length === 1) {
                    ret = null
                    return false
                }
                ret[key] = null
            }
        })
        return ret
    },

    urlParams(obj, isEncode) {
        isEncode = isEncode !== false
        let url = ''

        if (isObj(obj)) {
            for (let k in obj) {
                let value = obj[k] !== undefined ? obj[k] : ''
                url += `&${k}=${isEncode ? encodeURIComponent(value) : value}`
            }
        }
        return url ? url.substring(1) : ''
    },

    /**
   * 添加url参数
   * @param  {string} url    所需添加参数的url
   * @param  {obj}    params 添加的参数obj
   * @return {string}        添加参数后的url
   */
    build(url, params) {
        let data = Query.decode(url)

        each(params || {}, (val, key) => {
            data.params[key] = val
        })

        return Query.encode(data)
    },

    buildMp(url, params = {}) {
        const paramsStr = Query.urlParams(params)
        const separator = paramsStr
            ? url.indexOf('?') > -1
                ? '&' : '?'
            : ''
        return `${url}${separator}${paramsStr}`
    },

    constructUrl(url, params) {
        let obj = {}
        let hkCityId = 357
        let p1 = Query.decode(url)
        let p2 = Query.decode(window.location.href)

        let blackList = ['debug', 'id']

        // 过滤黑名单
        each(p2.params || {}, (val, key) => {
            if (blackList.indexOf(key) === -1) {
                obj[key] = val
            }
        })

        each(p1.params || {}, (val, key) => {
            if (blackList.indexOf(key) === -1) {
                obj[key] = val
            }
        })

        // 保证lang cityid直接透传
        if (obj.lang && obj.cityid) {
            // 多语言，lang，cityid 兜底逻辑
            let lang = obj.lang
            obj.cityid = parseInt(obj.cityid)
            let twReg = /^886500[0-9]{3}$/
            if (obj.lang === 'zh-TW' || twReg.test(obj.cityid)) {
                lang = 'zh-TW'
            }
            if (obj.lang === 'zh-HK' || obj.cityid === hkCityId) {
                lang = 'zh-HK'
            }
            obj.lang = lang
        }

        each(params || {}, (val, key) => {
            obj[key] = val
        })

        p1.params = obj
        return Query.encode(p1)
    },

    weixin(url, params) {
        return Query.build(url, params)
    },
    https(url) {
        return url.replace(/^http:/, '')
    },

    // get别名，用法同get方法
    query(key) {
        if (key) {
            return Query.get(key)
        }
        return Query.decode().params
    },
    hashQuery(key) {
        if (key) {
            return Query.get(key, '', { fromHash: true })
        }
        return Query.decode().hashParams
    }
}

export {
    Query,
    each,
    cloneDeep,
    findIdsByKey,
    getDomParent,
};
